var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderTrackingScripts = void 0;
const react_1 = __importDefault(require("react"));
const html_react_parser_1 = __importStar(require("html-react-parser"));
const utils_1 = require("./utils");
const renderTrackingScripts = (html, options) => utils_1.isDomReady && document.getElementsByClassName(`${options.id}-${options.placement}`).length < 1 && (0, html_react_parser_1.default)(html, {
  replace: domNode => {
    if (domNode instanceof html_react_parser_1.Element && domNode.attribs) {
      if (domNode.type === `script`) {
        let script = document.createElement(`script`);
        if (domNode.attribs.src) script.src = domNode.attribs.src;
        // @ts-ignore
        if (domNode.children.length) script.innerHTML = domNode.children[0].data;
        script.id = `${options.id}-${options.placement}-${Math.random().toString(36).substring(9)}`;
        script.className = `${options.id}-${options.placement}`;
        script.type = `text/javascript`;
        script.async = true;
        script.defer = true;
        if (options.placement === `head`) document.head.appendChild(script);
        if (options.placement === `body`) document.body.prepend(script);
        if (options.placement === `foot`) document.body.appendChild(script);
        return react_1.default.createElement(react_1.default.Fragment, {
          key: options.placement
        });
      }
    }
    return domNode;
  }
});
exports.renderTrackingScripts = renderTrackingScripts;